import { useTranslation } from 'react-i18next'
import { Button } from '@mui/material'

import { useRouter } from '@/hooks/router'

import { urls } from '@/utils/constants'

import * as styles from './Footer.css'

export const Footer = () => {
    const { t } = useTranslation()
    const router = useRouter()

    return (
        <footer className={styles.root}>
            <Button
                className={styles.link}
                size='small'
                onClick={() => router.push(urls.TERMS_OF_SERVICE)}
            >
                {t('termsOfService')}
            </Button>
        </footer>
    )
}
